import React, { Component } from 'react';
import CheckboxSection from "./CheckboxSection";

const ConfiguracionContraseniaDetallada = (props) => {
    return (
        <div className="left-separator-xs">

            <div className="row">
                <div className="">
                    <h5 className="configuracion-edit-text-strong">...Alfabético:</h5>
                </div>
                <div className="">
                    <div className="row row-radio">
                        <div className="col-xs-3">
                            <div className="container-radio radio-margin">
                                <input id="permiteLetrasConsecutivas2" type="radio" name="group1" checked={props.permiteLetrasConsecutivas} />
                                <label className="lbl-radio label-secondary" onClick={() => props.radioButtonChangeContrasenia({ identifier: "permiteLetrasConsecutivas", boolean: true })} >
                                    de forma consecutiva
                                </label>
                            </div>
                            <div className="subtitle-radio"> Ej: micontrasseña</div>
                        </div>


                        <div className="col-xs-3">
                            <div className="container-radio radio-margin">
                                <input id="permiteLetrasConsecutivas" type="radio" name="group1" checked={!props.permiteLetrasConsecutivas} />
                                <label className="lbl-radio label-secondary" onClick={() => props.radioButtonChangeContrasenia({ identifier: "permiteLetrasConsecutivas", boolean: false })} >
                                    en toda la contraseña
                                </label>
                            </div>
                            <div className="subtitle-radio"> Ej: micontraseña</div>
                        </div>
                    </div>



                </div>
            </div>
         

            <div className="row">
                <div className="">
                    <h5 className="configuracion-edit-text-strong">...Numérico:</h5>
                </div>
                <div className="">
                    <div className="row row-radio">
                        <div className="col-xs-3">
                            <div className="container-radio radio-margin">
                                <input id="permiteNrosConsecutivos2" type="radio" name="group2" checked={props.permiteNrosConsecutivos} />
                                <label className="lbl-radio label-secondary" onClick={() => props.radioButtonChangeContrasenia({ identifier: "permiteNrosConsecutivos", boolean: true })}>
                                    de forma consecutiva
                                </label>
                            </div>
                            <div className="subtitle-radio"> Ej: micontraseña11</div>
                        </div>


                        <div className="col-xs-3">
                            <div className="container-radio radio-margin">
                                <input id="permiteNrosConsecutivos" type="radio" name="group2" checked={!props.permiteNrosConsecutivos} />
                                <label className="lbl-radio label-secondary" onClick={() => props.radioButtonChangeContrasenia({ identifier: "permiteNrosConsecutivos", boolean: false })} >
                                    en toda la contraseña
                                </label>
                            </div>
                            <div className="subtitle-radio"> Ej: 1micontraseña1</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ConfiguracionContraseniaDetallada;